import { PeopleScreen } from '@/components/domain/members/PeopleScreen';

export default function PeopleBirthdaysScreen() {
  return <PeopleScreen listType="birthdays" />;
}
